import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  /* gap: 24px was here to space the now-removed inline breadcrumb row
     above the container — without that row the gap was just adding empty
     space below the (hidden) file input and pushing the container down by
     ~24px, which combined with the chrome's heights left the page taller
     than the viewport on some breakpoints, hence the page-level scrollbar
     the user reported. */
  height: 100%;
  min-height: 0;
  overflow: hidden;
  max-height: 100vh;
  box-sizing: border-box;

  .breadcrumb {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;

    @media (max-width: 1150px) {
      flex-wrap: wrap;
      gap: 8px;
    }

    .meta {
      display: flex;
      gap: 8px;

      div:not(:last-child) {
        border-right: 1px solid #cdd4df;
        padding-right: 6px;
      }
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 8px;

      @media (max-width: 1150px) {
        margin-left: auto;
      }

      button {
        background-color: #228be6;
        border-color: #228be6;

        &:disabled {
          border-color: #adb5bd;
        }

        svg {
          width: 16px;
          height: 16px;

          path {
            stroke: white;
          }
        }
      }

      label {
        span {
          width: 100px;
          height: 27px;
          border-radius: 7px;
          background: #3d3bff33;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
          line-height: 19.41px;
          text-align: center;
        }

        input {
          display: none;
        }
      }
    }
  }

  .container {
    padding: clamp(12px, 2.5vw, 24px);
    background-color: #fff;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .top-header {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 850px) {
        flex-wrap: wrap;
        gap: 8px;
      }

      button {
        color: #228be6;
        border-color: #228be6;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 19.6px */
        display: flex;
        gap: 8px;
        border-radius: 4px;
        padding: 0 16px;

        svg {
          width: 16px;
          height: 16px;

          path {
            stroke: #228be6;
          }
        }
      }

      .upload-file-btn {
        border: none;
        background: transparent;
      }

      .warning-text {
        display: flex;
        align-items: center;
        gap: 16px;
        border-radius: 4px;
        border: 1px solid #228be6;
        background: #fff;
        padding: 12px 12px 12px 16px;

        svg {
          path {
            stroke: #228be6;
          }
        }

        p {
          color: #25262b;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }

      .warning {
        display: flex;
        align-items: center;
        gap: 10px;
        p {
          color: #25262b;
          font-size: 14px;
          line-height: 140%;
        }
      }
      .loader {
        width: 50px;
        height: 50px;
        right: 39px;
        top: calc(50% - 25px);
        position: absolute;
        .CircularProgressbar-text {
          fill: #000;
        }
        .CircularProgressbar-path {
          stroke: #228be6;
        }
      }
    }
    .header {
      display: grid;
      grid-template-columns: 40px minmax(0, 1fr) minmax(0, 1fr);
      border: 1px solid #f1f3f5;
      border-bottom: none;
      border-radius: 8px 8px 0px 0px;
      background: #f8f9fa;
      position: relative;

      &.custom-report-type {
        grid-template-columns: 1fr 1fr;
      }

      .header-element {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: clamp(6px, calc(0.85vw + 0.5px), 10px) clamp(8px, calc(1.4vw + 0.5px), 16px);
        border-right: 1px solid #f1f3f5;
        min-width: 0;

        .actions {
          display: flex;
          align-items: center;
          gap: clamp(4px, 0.8vw, 8px);
          flex-shrink: 0;

          button {
            color: #228be6;
            font-size: clamp(12px, 1.2vw, 14px);
            white-space: nowrap;
          }

          .checkbox {
            display: flex;
            align-items: center;
            gap: clamp(4px, 0.8vw, 8px);
            margin-right: clamp(0px, 0.8vw, 8px);
            cursor: pointer;

            span {
              color: #101113;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 140%; /* 16.8px */
              white-space: nowrap;
            }
          }
        }

        .aif-amount {
          color: #868e96;
          font-size: clamp(12px, 1.2vw, 14px);
          font-weight: 600;
          line-height: 20px;
          white-space: nowrap;
        }

        .title {
          display: flex;
          align-items: center;
          gap: 8px;

          @media (max-width: 850px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 1px;
            flex: 1;
            min-width: 0;
            overflow: hidden;
          }

          p {
            &:first-child {
              color: #868e96;
              font-size: 14px;
              line-height: 20px;
              font-weight: 600;

              @media (max-width: 850px) {
                font-size: clamp(10px, 1.1vw, 12px);
                line-height: 14px;
                white-space: nowrap;
              }
            }
            &:last-child {
              color: #495057;
              font-size: 14px;
              line-height: 20px;
              font-weight: 600;

              @media (max-width: 850px) {
                font-size: clamp(10px, 1.1vw, 12px);
                line-height: 14px;
                white-space: nowrap;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }

    .table {
      border: 1px solid #f1f3f5;
      background: #edf0f5;
      flex: 1;
      min-height: 0;
      overflow: auto;

      .table-header {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        padding: 10px 39px;
        border-bottom: 1px solid #f1f3f5;
        gap: 50px;
        p {
          color: #2b313d;
          font-size: 16px;
          font-weight: 500;
        }
      }
      .row {
        display: flex;
        padding: 16px;
        border-bottom: 1px solid #f1f3f5;
        background-color: #fff;
      }
    }
  }
`;
